import { Spinner, styled } from '@erecruit/ui-kit';

export const ModalSpinner = styled(Spinner)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const TabSpinner = styled(Spinner)({
  position: 'absolute',
  top: '50%',
  left: '50%',
});
